import { inject, Injectable } from '@angular/core';
import { CookieOptions, CookieService } from 'ngx-cookie';
import { Observable, BehaviorSubject } from 'rxjs';
import { skipWhile } from 'rxjs/operators';
import { Token } from 'src/app/app.model';
import { NS_Enums } from 'src/app/static/namespace';
import { AuthService } from '../auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class CookiesService {

  private sharedCookieInterval: any = null;

  private _userData$ = new BehaviorSubject<any>(undefined);
  private cookieService: CookieService = inject(CookieService);
  public readonly userData$: Observable<any> = this._userData$.asObservable()
    .pipe(skipWhile(data => data === undefined || data === null));

  private data: { [key: string]: any } = {};

  private static cookieEndDate(): Date {
    const date = new Date();
    date.setDate(date.getDate() + 30);
    return date;
  }

  private static expiryTime(minutes: number): Date {
    const date = new Date();
    return new Date(date.getTime() + minutes * 60000)
  }

  get(key: string): string {
    return this.data[key] ? this.data[key] : this.cookieService.get(key);
  }

  getObject<T>(key: string): T {
    const cacheObj = this.data[key] ? this.data[key] as T : this.cookieService.getObject(key) as unknown as T;
    if (key === NS_Enums.cacheKeysEnum.saras_auth_key && cacheObj) {
      this._userData$.next({ err: null, user: cacheObj });
    } else if (key === NS_Enums.cacheKeysEnum.saras_auth_key && !cacheObj) {
      this._userData$.next({ err: true, user: null });
    }
    return cacheObj;
  }

  put(key: string, value: string, options?: CookieOptions) {
    this.data[key] = value;
    if (options && options.expires) {
      const expiryDate = CookiesService.expiryTime(Number(options.expires))
      this.cookieService.put(key, value, { expires: expiryDate });
    }
  }

  putObject<T>(key: string, value: T, cookie?: boolean) {
    this.data[key] = value;
    if (cookie) {
      this.cookieService.putObject(key, value as unknown as object, { expires: CookiesService.cookieEndDate() });
      if (key === NS_Enums.cacheKeysEnum.saras_auth_key) {
        this._userData$.next({ err: null, user: value });
      }
    }
  }

  remove(key: string) {
    delete this.data[key];
    this.cookieService.remove(key);
  }

  clear() {
    this.data = [];
    this.cookieService.removeAll();
  }

  /* Shared cookies for Global Login */
  addSharedCookie(tokenObj: any, key: string = NS_Enums.saras_global){
    try{
      const tokenStr = JSON.stringify(tokenObj);
      document.cookie = `${key}=${tokenStr}; domain=${this.isLocal ? 'localhost' : '.sarasanalytics.com'}; path=/; Secure; SameSite=None`;
    }
    catch(e){
      console.log(e);
    }
  }
  removeSharedCookie(key: string = NS_Enums.saras_global){
    document.cookie = `${key}=; domain=${this.isLocal ? 'localhost' : '.sarasanalytics.com'}; path=/; Secure; SameSite=None`;
  }

  removeSharedCookieInterval(){
    clearInterval(this.sharedCookieInterval);
    this.sharedCookieInterval = null;
  }

  private get isLocal() {
    return (
      location.hostname === 'localhost' || location.hostname === '127.0.0.1'
    );
  }
}
